import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { UserApiService } from '../../shared/services/api/user-api.service';

/**
 * Route guard for the CSM tenant-user access admin surface
 * (`/admin/memberships`).
 *
 * Reads the caller's DB-granted permissions from `GET /user/auth/me` and
 * activates the route only if `tenant_memberships.manage` is present.
 * Tenant users and super_users without the grant are bounced to `/home`.
 *
 * Mirrors `uiConfigAdminGuard` — same surface, different permission key,
 * so future per-feature admin pages can keep cloning this shape.
 */
export const tenantMembershipsAdminGuard: CanActivateFn = async () => {
  const userApi = inject(UserApiService);
  const router = inject(Router);
  try {
    const me = await firstValueFrom(userApi.getUserData());
    if (me.permissions?.includes('tenant_memberships.manage')) {
      return true;
    }
  } catch {
    // Network / auth issues fall through to redirect — the authTokenInterceptor
    // already handles the 401/403 cases at the HTTP layer.
  }
  return router.createUrlTree(['/home']);
};
